/**
 * This class manages the save/remove state for some specific page such as nrp and npr.
 * It is designed to store the state of the page
 */
var State = new Class({

	initialize: function() {
		// get states from cookies
		this.states = (Cookie.read('states') ? JSON.parse(Cookie.read('states')) : {});

		// this.states.nrp = {
		// 	criteria: {
		// 		'sale_rent': 2,
		// 		'types[]': ['2'],
		// 		'bedrooms[]': ['10', '12'],
		// 		'min_price': 3000,
		// 		'max_price': 10000,
		// 		'date_listed': 'month'
		// 	},
		// 	hood_id: '7',
		// 	building_id: 'building-724',
		// 	zoom: '14',
		// 	expanded: true,
		// 	page: 2
		// };
	}
});

State.implement({
	save: function(pageId, state) {
		this.states[pageId] = state;
		Cookie.write('states', JSON.stringify(this.states)); // session duration by default
	},

	remove: function(pageId) {
		delete this.states[pageId];
		Cookie.write('states', JSON.stringify(this.states)); // session duration by default
	},

	get: function(pageId) {
		if (pageId && this.states[pageId]) {
			return this.states[pageId];
		}
		return undefined;
	}
});
